import LocalStorageProvider from './LocalStorageProvider';

export default LocalStorageProvider;
